const translations = {
  "en": {
    "Hot Projects": "Hot Projects",
    "Top Chain": "Top Chain"
  },
  "zh-tw": {
    "Hot Projects": "熱門項目",
    "Top Chain": "熱門公鏈"
  }
};

export default translations;
